<template>
  <div class="step">
    <div class="step__question-group">
      <p class="step__question">
        How would you rate our ability to follow the timelines that were set
        during the implementation process?
      </p>
      <FormStarRating
        v-model="rating"
        label-left="Very poor"
        label-right="Very good"
      />
    </div>
    <div class="step__question-group">
      <FormBaseTextarea
        v-model="message"
        name="message"
        label="Please share any details or suggestions regarding the implementation timeline. (optional)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const rating = defineModel<number | null>('rating')
const message = defineModel<string>('message')
</script>

<style lang="scss" scoped>
.step {
  &__question {
    font-size: var(--font-size-paragraph-s);
    font-weight: 600;
    margin-bottom: 32px;
    line-height: 26px;

    &::after {
      content: '*';
      color: var(--red-500);
    }
  }

  &__question-group {
    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }
}
</style>
